import styled from '@emotion/styled';

import Form from 'components/form/Form';
import { ModalContent } from 'components/global/styled/Modal.styled';

import { Breakpoints } from 'utils/const.styles';

export const Content = styled(ModalContent)`
	display: ${({ showInstructions }) => (showInstructions ? 'grid' : 'block')};
	grid-template-columns: 1fr 1px 1fr;
	gap: var(--padding-2);
	flex: 1;
	overflow: ${({ showInstructions }) => (showInstructions ? 'hidden' : 'auto')};
	@media ${Breakpoints.mobile} {
		display: block;
		padding: var(--padding-5);
		overflow: auto;
	}
`;

export const Separator = styled.div`
	height: 1px;
	background-color: var(--border-color);
	margin-bottom: var(--padding-3);
`;

export const Instructions = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--padding-2);
	border: 1px solid var(--border-color);
	border-radius: var(--spacing-1);
	overflow: auto;
`;

export const InstructionsTitle = styled.div`
	padding: var(--padding-3);
	color: var(--black);
	background-color: var(--background-3);
	border-bottom: 1px solid var(--border-color);
`;

export const InstructionsContent = styled.div`
	padding: var(--padding-3);
`;

export const BlockForm = styled(Form)`
	display: block;
`;
